import React from 'react';
import { Container, IconWrapper, Title, Description } from './EmptyState.styled';

export interface EmptyStateProps {
  /** タイトル */
  title?: string;
  /** 詳細メッセージ */
  description?: string;
  /** アイコン（絵文字またはReactNode） */
  icon?: React.ReactNode;
  /** フルページ表示（min-height: 100vh） */
  fullPage?: boolean;
}

/**
 * 空状態表示コンポーネント
 * データがない場合の統一された表示を提供
 */
export const EmptyState: React.FC<EmptyStateProps> = ({
  title = 'データがありません',
  description,
  icon = '📭',
  fullPage = false,
}) => {
  return (
    <Container $fullPage={fullPage}>
      <IconWrapper>{icon}</IconWrapper>
      <Title>{title}</Title>
      {description && <Description>{description}</Description>}
    </Container>
  );
};

export default EmptyState;
